import { render, staticRenderFns } from "./ProductsFilterHorizontal.vue?vue&type=template&id=6964ade4"
import script from "./ProductsFilterHorizontal.vue?vue&type=script&lang=js"
export * from "./ProductsFilterHorizontal.vue?vue&type=script&lang=js"
import style0 from "./ProductsFilterHorizontal.vue?vue&type=style&index=0&id=6964ade4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports